export default __webpack_public_path__ + "static/media/orgplaceholder.2d6ed110.svg";